var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProMode = function SvgProMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M23.145.75c1.347 0 2.46 1.113 2.46 2.52v15a2.476 2.476 0 0 1-2.46 2.46h-5.04v2.52h-9.96v-2.52h-5.04a2.476 2.476 0 0 1-2.46-2.46v-15c0-1.407 1.113-2.52 2.46-2.52zm0 17.52v-15H3.105v15zM5.625 7.313v1.875h10.02V7.312zM18.75 9.188v1.582h-1.875V5.73h1.875v1.582h1.875v1.875zm-8.145 3.105v1.875h10.02v-1.875zM7.5 15.75v-1.582H5.625v-1.875H7.5V10.77h1.875v4.98z"
  })));
};
export default SvgProMode;